import React, { createContext, useContext, useState } from 'react';

// Định nghĩa kiểu dữ liệu cho một vessel (bạn có thể bổ sung thêm trường nếu cần)
export type Vessel = {
    unitId: string;
    vesselName: string | null | undefined;
    positions: any[];
    contactNumber: string | null | undefined;
    leafletMarker: L.Marker | null | undefined;
    windyMarker: L.Marker | null | undefined;
};

type VesselContextType = {
    vessels: Record<string, Vessel>;
    setVessels: React.Dispatch<React.SetStateAction<Record<string, Vessel>>>;
    vesselsPositionDataTimeRange: Array<[number, number]>;
    setVesselsPositionDataTimeRange: React.Dispatch<React.SetStateAction<Array<[number, number]>>>;
    currentPositionDataRange: [number, number];
    setCurrentPositionDataRange: React.Dispatch<React.SetStateAction<[number, number]>>;
};

const VesselContext = createContext<VesselContextType | undefined>(undefined);

export const VesselProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [vessels, setVessels] = useState<Record<string, Vessel>>({});
    const [vesselsPositionDataTimeRange, setVesselsPositionDataTimeRange] = useState<Array<[number, number]>>([]);
    const [currentPositionDataRange, setCurrentPositionDataRange] = useState<[number, number]>([0, 0]);
    return (
        <VesselContext.Provider value={{
            vessels, setVessels, vesselsPositionDataTimeRange,
            setVesselsPositionDataTimeRange,
            currentPositionDataRange,
            setCurrentPositionDataRange
        }}>
            {children}
        </VesselContext.Provider>
    );
};

// Custom hook để sử dụng VesselContext dễ dàng
export const useVesselContext = () => {
    const context = useContext(VesselContext);
    if (!context) throw new Error('useVesselContext must be used within VesselProvider');
    return context;
};